import _ from "lodash"

const prepareExtrudeConfig = (extrudeConfig) => {
  if (!extrudeConfig) return
  return _.reduce(
    extrudeConfig,
    (preparedExtrudeConfig, configArr, featureType) => {
      preparedExtrudeConfig[featureType] = _.reduce(
        configArr,
        (featureTypeConfig, configItem) => {
          const category = _.get(configItem, "category")
          const height = _.get(configItem, "height")

          if (category && height) _.set(featureTypeConfig, category, { height })

          return featureTypeConfig
        },
        {}
      )
      return preparedExtrudeConfig
    },
    {}
  )
}

export const prepareMapConfig = (mapConfig) => {
  if (!mapConfig) return
  const extrudeConfig = prepareExtrudeConfig(mapConfig.extrude)
  return { ...mapConfig, extrude: extrudeConfig }
}

export const prepareStepAutoplayConfig = (appConfig, deviceType) => {
  if (!appConfig) return
  const DEFAULT_AUTOPLAY_CONFIG = { delay: 3000, enable: false }
  const stepConfig = _.get(appConfig, `${deviceType}.autoplay.step`, {})
  return _.merge(DEFAULT_AUTOPLAY_CONFIG, stepConfig)
}

export const prepareSearchConfig = (appConfig, deviceType) => {
  if (!appConfig) return
  return _.get(appConfig, `${deviceType}.search`, {})
}
